import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { toast } from 'material-react-toastify';
import { ValidatedCoupon } from '../../interfaces/Coupon/ValidatedCoupon';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import { isTokenValid } from '../../utils/Auth';
import { getValidatedCoupon } from '../../api/Coupon';
import { useThemeColor } from '../../hooks/useThemeColor';

type CouponCardProps = {
  form: PaymentForm;
  onUseCoupon: (coupon: ValidatedCoupon) => void;
};

export const CouponCard = ({ form, onUseCoupon }: CouponCardProps) => {
  const { primary, secondary } = useThemeColor();

  const [code, setCode] = useState('');

  const handleSubmit = useCallback(() => {
    getValidatedCoupon(code)
      .then((x) => {
        toast.success('Kupon başarıyla uygulandı');
        onUseCoupon(x);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [code]);

  return isTokenValid() ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 1.5,
        alignItems: 'stretch',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 2.5,
          pt: 1,
          pb: 2,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          width: '100%',
        }}
      >
        <Typography sx={{ fontWeight: 700 }}>Kupon</Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <TextField
            disabled={!!form.couponAmount}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            size='small'
            fullWidth
          />

          <Button
            disabled={!!form.couponAmount || !code.length}
            variant='contained'
            onClick={handleSubmit}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '14px',
              color: secondary,
              backgroundColor: primary,
            }}
          >
            Onayla
          </Button>
        </Box>
      </Paper>
    </Box>
  ) : null;
};
